import { Heart, PartyPopper, Smile, ThumbsUp } from "@tamagui/lucide-icons";

export enum ActivityEventType {
  // Push enabled types
  Comment = "comment",
  StateChange = "state_change",

  Added = "added",
  Edited = "edited",
  Archived = "archived",
  Moved = "moved",

  // Data centric types
  DataAdded = "data_added",
  DataChanged = "data_changed",
  DataArchived = "data_archived",
  DataDeleted = "date_deleted",
}

export enum Reaction {
  ThumbsUp = "thumbs_up",
  Heart = "heart",
  Party = "party",
  Smile = "smile",
}

export const REACTIONS = [
  { icon: Heart, title: "Heart", type: Reaction.Heart },
  { icon: ThumbsUp, title: "Like", type: Reaction.ThumbsUp },
  { icon: PartyPopper, title: "Party", type: Reaction.Party },
  { icon: Smile, title: "Smile", type: Reaction.Smile },
];

export const ACTIVITY_PRIORITY_TYPES = [
  ActivityEventType.Added,
  ActivityEventType.Comment,
  ActivityEventType.StateChange,
];
